import type { ColDef, IRowNode } from 'ag-grid-community';
import { type BulkManageRow, type BulkManageUpdateFn } from '../types';
import { bulkManageSortFunction } from './bulkManageSortFunction';
import type { DetailedProxyMetadata } from 'venn-api';
import { isBulkManageCashRow, isBulkManageFundRow, isBulkManageOptionRow } from '../utils';
import { HoldingProxyCellRenderer, type HoldingProxyCellRendererParams } from './HoldingProxyCellRenderer';

const HOLDINGS_PROXY_COL_MIN_WIDTH = 160;

export const getHoldingsProxyColDef = (
  canEditProxies: boolean,
  onUpdate: BulkManageUpdateFn,
  openBulkHoldingsProxyModal: (row: IRowNode<BulkManageRow>) => void,
): ColDef<BulkManageRow, DetailedProxyMetadata | undefined> => {
  return {
    flex: 2,
    maxWidth: 350,
    minWidth: HOLDINGS_PROXY_COL_MIN_WIDTH,
    headerName: 'Holdings Proxy',
    sortable: true,
    field: 'fundHoldingsProxyInfo',
    comparator: bulkManageSortFunction({
      valueGetter: (value) => value?.proxyName,
    }),
    cellRendererSelector: ({ node }) => {
      return (isBulkManageFundRow(node.data) || isBulkManageCashRow(node.data) || isBulkManageOptionRow(node.data)) &&
        !node.group
        ? {
            component: HoldingProxyCellRenderer,
            params: {
              canEditProxies,
              onUpdate,
              openBulkHoldingsProxyModal,
            } satisfies HoldingProxyCellRendererParams,
          }
        : undefined;
    },
  };
};
